import { ImageFromCdn, Popover, ShowWhen } from '@/components'
import { Categories, ThemeColor } from '@/enums'
import { Info } from '@/icons'
import { useLanguage } from '@/utils'
import { useIsMobile } from '@/utils/hooks/useIsMobile'
import { ReactNode } from 'react'
import { graphicsImages, mobileGraphicsImages } from './helpers'
import { GraphicContainer, PopoverIconContainer } from './styles'

interface GraphicProps {
  categoryId: keyof typeof Categories
  popoverContent?: ReactNode
}

export const Graphic = ({ categoryId, popoverContent }: GraphicProps) => {
  const language = useLanguage()
  const { isMobile } = useIsMobile()

  const imageName = isMobile
    ? (mobileGraphicsImages[language] as Record<string, string>)[categoryId]
    : (graphicsImages[language] as Record<string, string>)[categoryId]

  return (
    <GraphicContainer>
      <ShowWhen when={Boolean(popoverContent)}>
        <PopoverIconContainer>
          <Popover content={popoverContent} dark>
            <Info
              color={ThemeColor.b50}
              cursor="pointer"
              fill="none"
              size="menu"
              stroke
            />
          </Popover>
        </PopoverIconContainer>
      </ShowWhen>
      <ImageFromCdn fallbackType="jpg" name={imageName} type="webp" />
    </GraphicContainer>
  )
}
